import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../globalModule/assets/icons/black_cross.png'
import _imports_1 from '../assets/code.svg'
import _imports_2 from '../assets/edit_params.svg'
import _imports_3 from '../assets/copy.svg'
import _imports_4 from '../assets/trash2.svg'


const _withScopeId = n => (_pushScopeId("data-v-e2b9c7c8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modal" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Custom Message", -1))
const _hoisted_6 = { class: "alignIcons" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "code icon"
}, null, -1))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = { class: "table" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", { class: "table-header" }, [
  /*#__PURE__*/_createElementVNode("th", null, "Name"),
  /*#__PURE__*/_createElementVNode("th", null, "Type"),
  /*#__PURE__*/_createElementVNode("th", null, "Constant Value")
], -1))
const _hoisted_11 = { class: "action-container" }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  height: "20",
  width: "20",
  alt: "edit param"
}, null, -1))
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = ["onClick"]
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  height: "20",
  width: "20",
  alt: "inspect param"
}, null, -1))
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = ["onClick"]
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  height: "20",
  width: "20",
  alt: "delete param"
}, null, -1))
const _hoisted_20 = [
  _hoisted_19
]
const _hoisted_21 = ["onUpdate:modelValue"]
const _hoisted_22 = ["value", "checked", "onChange"]
const _hoisted_23 = ["onUpdate:modelValue"]
const _hoisted_24 = { class: "action-container" }
const _hoisted_25 = ["onClick"]
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "activeSave",
  src: _imports_2,
  height: "20",
  width: "20",
  alt: "edit param"
}, null, -1))
const _hoisted_27 = [
  _hoisted_26
]
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  class: "icon-button",
  disabled: ""
}, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_3,
    height: "20",
    width: "20",
    alt: "copy param"
  })
], -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  class: "icon-button",
  disabled: ""
}, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_4,
    height: "20",
    width: "20",
    alt: "delete param"
  })
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_fa = _resolveComponent("fa")!
  const _component_SearchableDropDown = _resolveComponent("SearchableDropDown")!

  return (_ctx.ncStore.editingMsg)
    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("button", {
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onExitModal())),
                class: "icon-button"
              }, _hoisted_4),
              _hoisted_5,
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("button", {
                  class: "icon-button",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.openCode()))
                }, _hoisted_8)
              ])
            ]),
            _withDirectives(_createElementVNode("input", {
              class: "input-style",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.ncStore.editingMsg.name) = $event)),
              placeholder: "Enter Service Name ..."
            }, null, 512), [
              [_vModelText, _ctx.ncStore.editingMsg.name]
            ]),
            _createElementVNode("h3", null, [
              _createTextVNode(" Request Params "),
              _createElementVNode("button", {
                class: "icon-button add-param-button",
                title: "Create new message type",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.addNewParam()))
              }, [
                _createVNode(_component_fa, { icon: "plus" })
              ])
            ]),
            _createElementVNode("table", _hoisted_9, [
              _hoisted_10,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ncStore.editingMsg.fields, (item) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: item.id
                }, [
                  (!_ctx.editModeParams.includes(item.id))
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createElementVNode("td", null, _toDisplayString(item.name), 1),
                        _createElementVNode("td", null, _toDisplayString(_ctx.getMessageFieldName(item)), 1),
                        _createElementVNode("td", null, _toDisplayString(item.constantValue), 1),
                        _createElementVNode("td", null, [
                          _createElementVNode("div", _hoisted_11, [
                            _createElementVNode("button", {
                              class: "icon-button",
                              onClick: () => _ctx.onEditParam(item.id)
                            }, _hoisted_14, 8, _hoisted_12),
                            _createElementVNode("button", {
                              class: "icon-button",
                              onClick: () => _ctx.onDup(item)
                            }, _hoisted_17, 8, _hoisted_15),
                            _createElementVNode("button", {
                              class: "icon-button",
                              onClick: () => _ctx.onDeleteParam(item.id)
                            }, _hoisted_20, 8, _hoisted_18)
                          ])
                        ])
                      ], 64))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createElementVNode("td", null, [
                          _withDirectives(_createElementVNode("input", {
                            class: "editInput",
                            "onUpdate:modelValue": ($event: any) => ((item.name) = $event)
                          }, null, 8, _hoisted_21), [
                            [_vModelText, item.name]
                          ])
                        ]),
                        _createElementVNode("td", null, [
                          _createVNode(_component_SearchableDropDown, {
                            options: _ctx.globalStore.getMessages(),
                            "max-item": 10,
                            "initially-selected": _ctx.globalStore.getMessage(item.msg),
                            onSelected: (msg) => _ctx.chooseParamMsgType(item.id, msg)
                          }, null, 8, ["options", "initially-selected", "onSelected"])
                        ]),
                        _createElementVNode("td", null, [
                          _createElementVNode("input", {
                            type: "checkbox",
                            value: item.id,
                            checked: item.constantValue !== undefined,
                            onChange: () => _ctx.onConstBoxClicked(item)
                          }, null, 40, _hoisted_22),
                          (item.constantValue !== undefined)
                            ? _withDirectives((_openBlock(), _createElementBlock("input", {
                                key: 0,
                                class: "editInput",
                                "onUpdate:modelValue": ($event: any) => ((item.constantValue) = $event)
                              }, null, 8, _hoisted_23)), [
                                [_vModelText, item.constantValue]
                              ])
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("td", null, [
                          _createElementVNode("div", _hoisted_24, [
                            _createElementVNode("button", {
                              class: "icon-button",
                              onClick: () => _ctx.onEditParam(item.id)
                            }, _hoisted_27, 8, _hoisted_25),
                            _hoisted_28,
                            _hoisted_29
                          ])
                        ])
                      ], 64))
                ]))
              }), 128))
            ])
          ])
        ]),
        _createElementVNode("div", {
          class: "dialog-bg",
          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.onExitModal()))
        })
      ], 64))
    : _createCommentVNode("", true)
}